import { memo } from "react";

function PumpJack(props: { size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        background: "transparent",
        backgroundColor: "transparent",
        colorScheme: "light"
      }}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.size}
      height={props.size}
      viewBox="-0.5 -0.5 207 217"
      {...props}>
      <defs />
      <g>
        <g data-cell-id={0}>
          <g data-cell-id={1}>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-1">
              <g>
                <path
                  d="M 105 199 L 80 199 Q 70 199 71.66 189.14 L 88.34 89.86 Q 90 80 100 80 L 110 80 Q 120 80 121.66 89.86 L 138.34 189.14 Q 140 199 130 199 Z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={16}
                  strokeMiterlimit={10}
                  pointerEvents="all"
                  style={{
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-23">
              <g>
                <rect
                  x={26.77}
                  y={38.54}
                  width={65}
                  height={22.76}
                  rx={3.41}
                  ry={3.41}
                  fill="currentColor"
                  stroke="currentColor"
                  transform="rotate(15,59.27,49.92)"
                  pointerEvents="all"
                  style={{
                    fill: "currentColor",
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-12">
              <g>
                <rect
                  x={3}
                  y={189}
                  width={202}
                  height={25}
                  rx={3.75}
                  ry={3.75}
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth={3}
                  pointerEvents="all"
                  style={{
                    fill: "currentColor",
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-19">
              <g />
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-17">
              <g>
                <path
                  d="M 5 85.76 L 14.53 53.66 L 36.77 53.66 L 46.3 85.76 Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth={3}
                  strokeMiterlimit={10}
                  transform="rotate(-165,25.65,69.71)"
                  pointerEvents="all"
                  style={{
                    fill: "currentColor",
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-18">
              <g>
                <rect
                  x={18.92}
                  y={20.3}
                  width={28.72}
                  height={42.59}
                  rx={4.31}
                  ry={4.31}
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth={3}
                  transform="rotate(-75,33.28,41.59)"
                  pointerEvents="all"
                  style={{
                    fill: "currentColor",
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-21">
              <g>
                <path
                  d="M 19.21 29.1 L 28.74 6 L 50.98 6 L 60.51 29.1 Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth={3}
                  strokeMiterlimit={10}
                  transform="rotate(15,39.86,17.55)"
                  pointerEvents="all"
                  style={{
                    fill: "currentColor",
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-22">
              <g>
                <ellipse
                  cx={105}
                  cy={63}
                  rx={17}
                  ry={17}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={8}
                  pointerEvents="all"
                  style={{
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-24">
              <g>
                <path
                  d="M 22 203.5 L 22 69.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={10}
                  strokeMiterlimit={10}
                  pointerEvents="stroke"
                  style={{
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-25">
              <g>
                <rect
                  x={161}
                  y={160.5}
                  width={44}
                  height={25}
                  rx={1.25}
                  ry={1.25}
                  fill="currentColor"
                  stroke="currentColor"
                  transform="rotate(-90,183,173)"
                  pointerEvents="all"
                  style={{
                    fill: "currentColor",
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="WwYRowCrJP4RlbPx8YWF-26">
              <g>
                <path
                  d="M 183 162.24 L 183 87"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={10}
                  strokeMiterlimit={10}
                  pointerEvents="stroke"
                  style={{
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
            <g data-cell-id="F-oYtSULTeaT5PZd1EHi-1">
              <g>
                <rect
                  x={118.72}
                  y={64}
                  width={72.16}
                  height={22.76}
                  rx={3.41}
                  ry={3.41}
                  fill="currentColor"
                  stroke="currentColor"
                  transform="rotate(15,154.8,75.38)"
                  pointerEvents="all"
                  style={{
                    fill: "currentColor",
                    stroke: "currentColor"
                  }}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default memo(PumpJack);
